// extracted by mini-css-extract-plugin
module.exports = {"root":"Images90_root__3MLvh","title":"Images90_title__2N7zz","images":"Images90_images__15IKA"};